import { gql } from '../../../../__generated__/graphql/catalog'

export const CREATE_IDME_SHOPIFY_DISCOUNT_CODE = gql(`
  mutation createIdmeShopifyDiscountCode($authCode: String!, $source: String!) {
    createIdmeShopifyDiscountCode(authCode: $authCode, source: $source)
  }
`)
